import React, { useEffect, useState } from "react";
import YearlyCommonDashboard from "../YearlyCommonDashboard/YearlyCommonDashboard";
import { GetShareRegisterReport } from "../../../../Helpers/APIEndPoints/EndPoints";

const ShareRegisterReport = () => {
  return (
    <>
      <YearlyCommonDashboard
        PageName="ShareRegister"
        ExportToExcelUrl={GetShareRegisterReport}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default ShareRegisterReport;
